import { AccountGroup, AccountGroupProfile, LifecycleStatus, ReviewStatus } from '@ndvr/portfolio-api';

import { sortByDate } from './date-utils';

const lifecycleStatusOrder = [
    LifecycleStatus.REAL,
    LifecycleStatus.ONBOARDING,
    LifecycleStatus.DRAFT,
    LifecycleStatus.CLOSED,
];

export const sortAccountGroupProfiles = (accountGroupProfiles: AccountGroupProfile[] = []): AccountGroupProfile[] =>
    accountGroupProfiles.sort((a, b) => {
        const lifecycleStatusSortValue =
            lifecycleStatusOrder.indexOf(a.accountGroup.lifecycleStatus) -
            lifecycleStatusOrder.indexOf(b.accountGroup.lifecycleStatus);
        return lifecycleStatusSortValue || sortByDate(a.accountGroup.updatedAt, b.accountGroup.updatedAt);
    });

export const isAccountGroupLocked = (accountGroup: AccountGroup) => {
    return ReviewStatus.APPROVED === accountGroup.reviewStatus;
};
